import nodeProcess from 'node:process';
import { quiz as quizBaseline } from '@/common/quiz/quiz_v1.ts';
import type { GoalsModel, QuizCollectionModel, QuizConfigModel, QuizOptionsModel } from '@/common/models/quiz.model';

export function useQuiz() {
  const {
    $quiz,
    $db,
  } = useNuxtApp();
  const route = useRoute();
  const selectedAnswer = ref<number | QuizOptionsModel>();
  const { main_goal, secondary_goal } = route.query;
  const goals = ref({ main: main_goal as string });

  function setGoals(newGoals: GoalsModel): void {
    goals.value = newGoals;
    $db?.setItem('goals', newGoals);
  }

  async function saveAnswerToLocally(answerId: number | string) {
    const localQuiz = await $db?.getItem('quiz');
    const savedQuiz = currentQuestionId.value === 'q0' ? {} : localQuiz;

    savedQuiz[currentQuestionId.value] = answerId;
    // Записываем ответы в объект, где ключ объекта id вопроса, а value объекта это id ответа
    $db?.setItem('quiz', savedQuiz);
  }

  const currentQuestionId = computed((): string => {
    return route.params.id as string;
  });

  const currentQuestion = computed((): QuizConfigModel => {
    return quiz.value[route.params.id as string];
  });

  const nextLink = computed((): string => {
    return currentQuestion.value?.nextLink as string;
  });

  const prevLink = computed((): string => {
    const link = currentQuestion.value.prevLink;

    if (Number.isInteger(link)) {
      return `/quiz/${link}/${quiz.value[Number(link)].type}`;
    }

    return `${link}`;
  });

  const currentProgress = computed((): number => {
    if (nextLink.value === '/quiz/creating-plan') {
      return 100;
    }
    return currentQuestion.value?.progress;
  });

  const quiz = computed((): QuizCollectionModel => {
    return $quiz?.value.quiz as QuizCollectionModel;
  });

  return {
    currentQuestionId,
    currentQuestion,
    selectedAnswer,
    nextLink,
    prevLink,
    currentProgress,
    setGoals,
    goals,
    saveAnswerToLocally,
    quiz,
  };
}
